import { FC } from 'react'

interface NumberFormatProps {
  value: number | string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

const NumberFormat: FC<NumberFormatProps> = (props) => {
  const {
    value,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    ...restProps
  } = props

  const numberFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
    ...restProps,
  })

  return <>{numberFormatter.format(+value)}</>
}

export default NumberFormat
